import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupIdEfficiency = z.any()
export type TagsGetEdc_sharing_groupIdEfficiency = z.infer<typeof tagsGetEdc_sharing_groupIdEfficiency>

export const paramsGetEdc_sharing_groupIdEfficiency = z.object({ "groupId": z.string() })
export type ParamsGetEdc_sharing_groupIdEfficiency = z.infer<typeof paramsGetEdc_sharing_groupIdEfficiency>

export const querystringGetEdc_sharing_groupIdEfficiency = z.object({ "from": z.string().date(), "to": z.string().date(), "thresholdPercent": z.number().gte(0).lte(100), "startHour": z.number().int().gte(0).lte(23), "endHour": z.number().int().gte(1).lte(24), "maxExportKw": z.number().gte(0).lte(1000000).optional() })
export type QuerystringGetEdc_sharing_groupIdEfficiency = z.infer<typeof querystringGetEdc_sharing_groupIdEfficiency>

export const responseGetEdc_sharing_groupIdEfficiency = z.object({ "payload": z.object({ "excludedIntervals": z.number(), "hours": z.array(z.object({ "period": z.string(), "generation": z.number(), "exported": z.number(), "peakExportKw": z.number(), "exportedPercent": z.number(), "intervalCount": z.number(), "inefficient": z.boolean() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetEdc_sharing_groupIdEfficiency = z.infer<typeof responseGetEdc_sharing_groupIdEfficiency>

interface IGetEdc_sharing_groupIdEfficiency extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupIdEfficiency,
  params: ParamsGetEdc_sharing_groupIdEfficiency,
  querystring: QuerystringGetEdc_sharing_groupIdEfficiency,
  response: ResponseGetEdc_sharing_groupIdEfficiency
}
export const URL = '/edc-sharing/:groupId/efficiency'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupIdEfficiency,
    params: paramsGetEdc_sharing_groupIdEfficiency,
    querystring: querystringGetEdc_sharing_groupIdEfficiency,
    response: responseGetEdc_sharing_groupIdEfficiency
  }
}
export interface Edc_sharing_groupIdEfficiency extends BaseRouteType {
  get: IGetEdc_sharing_groupIdEfficiency
}